<template>
	<component v-bind="pages[$route.name || 'index']"></component>
</template>

<script>
import Index from '@/routes/App/Account/Transactions/Index'
import Details from '@/routes/App/Account/Transactions/Details'

export default {
	name: 'Transactions',

	metaInfo() {
		return {
			title: this.$i18n.t('route.account_transactions'),
			meta: [
				{ property: 'og:title', content: this.$i18n.t('route.account_transactions') },
				{ property: 'og:url', content: window.location.href },
			],
		};
	},

	data: () => ({
		pages: {},
	}),

	created() {
		this.$route.meta.section = this.$i18n.t('route.account_transactions');
		if (this.$route.meta.sub) {
			this.$route.meta.sub = this.$root.user.data.firstname;
		}

		this.pages = {
			account_section: { is: Index },
			account_section_sub: { is: Details },
		};
	},
}
</script>
